import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function Puff() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          padding: "60px 0 20px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Vegetable Puff</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 16 }}>The Vegetable Puff is a flaky, buttery pastry filled with a savory vegetable mixture, perfect as a snack or appetizer.</p>
          <span className="season-badge season-fall">🍂 Best in Fall</span>
          <ImageWithFallback src="/puff.jpg" alt="VegetablePuff" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 16 }} />
        </section>
        <section className="recipe-columns-anim" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "20px 0 0 0",
          maxWidth: 1200,
          margin: "0 auto"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Ingredients</h2>
            <ul className="ingredient-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>2 medium sliced onions</li>
              <li>1 tsp ginger-garlic paste</li>
              <li>1/4 tsp turmeric powder</li>
              <li>1/2 tsp cumin powder</li>
              <li>1 tsp coriander powder</li>
              <li>1/2 tsp garam masala</li>
              <li>1/2 tsp red chili powder</li>
              <li>1 small chopped tomato </li>
              <li>1 medium chopped potato</li>
              <li>1 medium chopped carrot</li>
              <li>1/2 cup fresh or frozen peas</li>
              <li>2 tbsp oil</li>
              <li>Salt to taste</li>
              <li>Fresh cilantro for garnish</li>
            </ul>
          </div>
          <div style={{ flex: 2, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Instructions</h2>
            <ol className="instructions-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Heat oil in a pan and saute onion for two minutes</li>
              <li>Add ginger-garlic paste and sauté until the raw flavor dissapears.</li>
              <li>Add 1 small chopped tomato and saute for two minutes</li>
              <li>Add turmeric, coriander powder, red chili powder, and salt. Stir well.</li>
              <li>Add the potato, carrot and peas. Then saute for 1 minute</li>
              <li>Add the coriander and stir for a few soconds</li>
              <li>Let it cool completly and then add it in your puff pastry dough and bake it at 482 degress Farenheit for 25 - 30 minutes </li>
            </ol>
          </div>
        </section>
        <section style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 24px 60px 24px", display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div className="chef-tips-box" style={{ flex: 1, minWidth: 300, background: "#f8f9fa", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Let the vegetable filling cool completely before filling the pastry — warm filling melts the butter layers and stops them from puffing up.</li>
              <li>Chop the vegetables small and uniform so the filling cooks evenly and fits neatly inside the pastry.</li>
              <li>Keep the puff pastry cold until it goes into the oven for the flakiest, crispiest layers.</li>
              <li>Brush the tops with a little milk or egg wash for an extra golden, glossy finish.</li>
            </ul>
          </div>
          <div className="health-benefits-box" style={{ flex: 1, minWidth: 300, background: "#eef9f0", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>The vegetable filling adds fiber, vitamins, and minerals to what's otherwise a simple pastry snack.</li>
              <li>Peas and carrots contribute vitamin A and plant protein.</li>
              <li>Baking rather than deep-frying keeps this snack lighter than many fried alternatives.</li>
              <li>A good way to use up small amounts of leftover vegetables without any waste.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default Puff;
